enum NavigationIndex
{
    DASHBOARD       = "1",
    CUSTOMER        = "2",
    CATEGORY        = "3",
    REFERENCE       = "4",
    TARGETGROUP     = "5",
    QUESTION        = "6",
    TICKETLIST      = "7",
    TEST            = "8",
    ROLE            = "9",
    USER            = "10",
    SOURCE          = "11",
    CLIENT          = "12"
}

export default NavigationIndex
